import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-socialview',
  templateUrl: './socialview.component.html',
  styleUrls: ['./socialview.component.css']
})
export class SocialviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
